/**
 * Shared form-control surface.
 *
 * Adapted from shadcn new-york-v4 (`bg-transparent shadow-xs dark:bg-input/30`)
 * for a tinted page canvas: light mode uses the elevated card fill so fields
 * remain visible outside cards; dark mode keeps the translucent input fill.
 */
export const formControlSurfaceClass =
  'border-input bg-card shadow-xs dark:bg-input/30';

/** Animated border + focus ring for text inputs, textareas, and selects. */
export const formControlFocusTransition =
  'transition-[color,box-shadow,border-color] duration-200 ease-out';
